//---------------
// get player id
//---------------
export default function getPlayerId(player_name, playerArrayWithEmail, playerArrayWithId) {
  const player = Array.isArray(playerArrayWithEmail)
    ? playerArrayWithEmail.find(
        (entry) =>
          entry.first_name == player_name ||
          entry.user_name == player_name ||
          entry.email == player_name,
      )
    : null

  if (!player || !Array.isArray(playerArrayWithId)) {
    return null
  }

  const playerMembership = playerArrayWithId.find(
    (entry) =>
      entry.player == player.id ||
      entry.player == player.email ||
      entry.player_email == player.email,
  )

  return playerMembership?.id ?? null
}
